import * as A from '@/store/mutation-types';
import { Store } from 'vuex';

const config = require('./data.json');
export class DataService {
  private _status = [
    { name: 'Ready', value: 'x:ready' },
    { name: 'Pending', value: 'x:pending' },
    { name: 'Partial', value: 'x:partial' },
    { name: 'Error', value: 'x:error' },
    { name: 'Client Message', value: 'x:client-message' },
    { name: 'Canceled', value: 'x:canceled' }
  ];
  private _instanceNames = ['clubs', 'leagues', 'sports', 'tshq'];

  private _roles = [
    {
      title: 'Administrator',
      value: 'admin'
    },
    {
      title: 'Customer Service',
      value: 'csr'
    }
  ];

  private _ngbids = [];
  constructor(private store: Store<any>) {
    this._ngbids = config.map(x => {
      return {
        id: x.id,
        name: x.name,
        title: `${x.id} - ${x.name}`
      };
    });
  }
  public ngbids() {
    return this._ngbids;
  }
  public instanceNames() {
    return this._instanceNames;
  }
  public status() {
    return this._status;
  }
  public roles() {
    return this._roles;
  }
  public setDialogState(state: boolean) {
    this.store.commit(A.SET_DIALOG_STATE, state);
  }
}
